module.exports = __webpack_public_path__ + "static/img/huawei-appgallery-badge-pt.0d2e1ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/huawei-appgallery-badge-pt.png
// module id = r7EW
// module chunks = 1